/** Figma 96138:33168 base curve — shorter With Ed series shifts endpoint left. */
const BASE_ON_YOUR_OWN = [4, 19, 36, 57, 81, 100] as const;
const BASE_WITH_ED = [4, 22, 45, 72, 100] as const;

export function buildDebtLineSeries(
  onYourOwnYears: number,
  withEdYears: number,
): { onYourOwn: number[]; withEd: number[] } {
  const onYourOwn = [...BASE_ON_YOUR_OWN];
  const ratio = Math.min(1, withEdYears / Math.max(onYourOwnYears, 0.01));
  const edLength = Math.max(
    3,
    Math.min(onYourOwn.length, Math.round(onYourOwn.length * ratio)),
  );
  const withEd = [...BASE_WITH_ED.slice(0, edLength)];
  withEd[withEd.length - 1] = 100;

  return { onYourOwn, withEd };
}
